module.exports = __webpack_public_path__ + "img/kistimldms_03.4b706d0b.png";